import React from 'react';
import { useTranslation } from 'react-i18next';

import { RadioButton } from '@common/components/radio-button/radio-button';
import type { Predicate } from '@common/types/objects';
import { EPredicateOperators } from '@common/definitions';
import { normalizePredicateBooleanValue } from '@modules/user-properties/utils/custom-user-property-predicate';

type PredicateSelectorBooleanProps = {
  predicate: Predicate;
  onChange: (newPredicate: Partial<Predicate>) => void;
};

export const PredicateSelectorBoolean = ({
  predicate,
  onChange: parentOnChange,
}: PredicateSelectorBooleanProps) => {
  const { t } = useTranslation();

  const currentValue = normalizePredicateBooleanValue(predicate.value) ?? true;

  const options = [
    { value: true, label: t('common:predicates_filter_user_property_yes') },
    { value: false, label: t('common:predicates_filter_user_property_no') },
  ];

  const onChange = (value: boolean) => parentOnChange({
    comparison: EPredicateOperators.EQ,
    value,
  });

  return (
    <>
      {options.map((option) => (
        <div
          key={String(option.value)}
          className="dropdown-radio tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-px-3 tw-py-2
          tw-text-base hover:tw-bg-gray-custom-100 dark:hover:tw-bg-dark-overlay"
          onClick={(event) => {
            event.stopPropagation();
            onChange(option.value);
          }}
        >
          <RadioButton
            value={option.value}
            currentValue={currentValue}
            label={option.label}
            onChange={(value) => onChange(value as boolean)}
          />
        </div>
      ))}
    </>
  );
};
